/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LearnerPerformanceRequest { 
    resultField?: string | null;
    bucketSize?: number;
    quizId?: string | null;
    actualQuizId?: string | null;
    grade?: string | null;
    startDateUtc?: string | null;
    endDateUtc?: string | null;
}

